import kebab from 'lodash/fp/kebabCase';
import flatten from 'lodash/flatten';

export const getHelpfulArticles = () => {
  const ctx = require.context(
    '!babel-loader!markdown-with-front-matter-loader!../../helpful-articles',
    true,
    /(\.md)$/,
  );
  return ctx
    .keys()
    .map(filePath => ctx(filePath))
    .reduce((acc, file) => {
      if (!acc[file.category]) {
        acc[file.category] = { articles: [] };
      }
      acc[file.category].articles.push({ ...file, path: kebab(file.title) });
      return acc;
    }, {});
};

export const getHelpfulArticleByPath = path => {
  return flatten(
    Object.entries(getHelpfulArticles()).map(([key, cat]) => cat.articles),
  ).find(a => a.path === path);
};

export const getArticlesByCategory = category => {
  const categories = getHelpfulArticles();
  if (categories[category]) {
    return categories[category].articles;
  } else {
    return null;
  }
};
